import { components } from 'react-select';

import { NoOptionsMessageProps } from './NoOptionsMessage.types';

export const NoOptionsMessage = ({ children, ...rest }: NoOptionsMessageProps) => {
  return (
    <components.NoOptionsMessage {...rest}>{children || 'No options'}</components.NoOptionsMessage>
  );
};
